import { InjectionToken } from '@angular/core';

export const Window = new InjectionToken<Window>('Global window object');
